/* AUTO-GENERATED by scripts/generate-fight-world-expansion.mjs. Do not hand edit. */
import type { ArenaDef } from './content'
import type { WorldComposition } from './worldExpansionTypes'
export const WORLD_LIBRARY_URLS:Record<string,string>={
  "megalithicTemple": "/elyon/world-library/prop/megalithicTemple.glb",
  "astralGateway": "/elyon/world-library/prop/astralGateway.glb",
  "capitalTower": "/elyon/world-library/prop/capitalTower.glb",
  "capitalWall": "/elyon/world-library/prop/capitalWall.glb",
  "ancientRuins": "/elyon/world-library/prop/ancientRuins.glb",
  "crystalTemple": "/elyon/world-library/prop/crystalTemple.glb",
  "elyonGateway": "/elyon/world-library/prop/elyonGateway.glb",
  "guardianEast": "/elyon/world-library/prop/guardianEast.glb",
  "guardianWest": "/elyon/world-library/prop/guardianWest.glb",
  "seraphimGuardian": "/elyon/world-library/prop/seraphimGuardian.glb",
  "ruinArch": "/elyon/world-library/prop/ruinArch.glb",
  "brokenPillar": "/elyon/world-library/prop/brokenPillar.glb",
  "ceremonialAltar": "/elyon/world-library/prop/ceremonialAltar.glb",
  "toppledStatue": "/elyon/world-library/prop/toppledStatue.glb",
  "elyonArch": "/elyon/world-library/prop/elyonArch.glb",
  "elyonColumn": "/elyon/world-library/prop/elyonColumn.glb",
  "wallCorner": "/elyon/world-library/prop/wallCorner.glb",
  "wallSegment": "/elyon/world-library/prop/wallSegment.glb",
  "humanWall": "/elyon/world-library/prop/humanWall.glb",
  "capitalObelisk": "/elyon/world-library/prop/capitalObelisk.glb",
  "skyFortress": "/elyon/world-library/monster/skyFortress.glb",
  "astralLeviathan": "/elyon/world-library/monster/astralLeviathan.glb",
  "skyTitan": "/elyon/world-library/monster/skyTitan.glb",
  "voidMatriarch": "/elyon/world-library/monster/voidMatriarch.glb",
  "thermalWyvern": "/elyon/world-library/monster/thermalWyvern.glb",
  "astryx": "/elyon/world-library/monster/astryx.glb",
  "stormPatriarch": "/elyon/world-library/monster/stormPatriarch.glb",
  "crystalDragon": "/elyon/world-library/monster/crystalDragon.glb",
  "phoenixPrime": "/elyon/world-library/monster/phoenixPrime.glb",
  "ancientColossus": "/elyon/world-library/monster/ancientColossus.glb",
  "tempestTitan": "/elyon/world-library/monster/tempestTitan.glb",
  "abyssalMaw": "/elyon/world-library/monster/abyssalMaw.glb",
  "magmaLeviathan": "/elyon/world-library/monster/magmaLeviathan.glb",
  "shadowLeviathan": "/elyon/world-library/monster/shadowLeviathan.glb",
  "voidLeviathan": "/elyon/world-library/monster/voidLeviathan.glb",
  "petragon": "/elyon/world-library/monster/petragon.glb"
}

export const SCENARIO_FAMILY_BY_ARENA:Record<string,string>={
  "megalithic-sanctum": "aurelios",
  "ancestral-invasion": "aurelios",
  "astral-threshold": "capital",
  "capital-siege": "capital",
  "sky-fortress-assault": "capital",
  "ruined-kingdom": "aurelios",
  "crystal-cathedral": "xyloria",
  "void-citadel": "capital",
  "storm-temple": "capital",
  "titan-sanctum": "aurelios",
  "verdant-ruins": "xyloria",
  "magma-throne": "aurelios",
  "abyssal-rift": "capital",
  "celestial-bastion": "xyloria",
  "phoenix-temple": "aurelios",
  "thermal-spires": "aurelios",
  "shadow-leviathan": "capital",
  "void-leviathan-gate": "capital"
}

export const WORLD_COMPOSITIONS:Record<string,WorldComposition>={
  "megalithic-sanctum": {
    "family": "aurelios",
    "pieces": [
      {
        "id": "megalithic-sanctum-world-0",
        "asset": "ruinArch",
        "position": [
          -11.16,
          0,
          -10.504
        ],
        "rotationY": -0.22,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "megalithic-sanctum-world-1",
        "asset": "brokenPillar",
        "position": [
          12.84,
          0,
          -10.504
        ],
        "rotationY": 0.33,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "megalithic-sanctum-world-2",
        "asset": "ceremonialAltar",
        "position": [
          -14.06,
          0,
          -15.336
        ],
        "rotationY": -0.44,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "megalithic-sanctum-world-3",
        "asset": "elyonColumn",
        "position": [
          13.78,
          0,
          -15.168
        ],
        "rotationY": 0.55,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "megalithic-sanctum-world-4",
        "asset": "ruinArch",
        "position": [
          -8.5,
          0,
          -20
        ],
        "rotationY": -0.66,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "megalithic-sanctum-world-5",
        "asset": "brokenPillar",
        "position": [
          8.22,
          0,
          -20.168
        ],
        "rotationY": 0.77,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "megalithic-sanctum-aerial-boss",
        "asset": "skyTitan",
        "position": [
          -3.5,
          7.5,
          -23
        ],
        "rotationY": 0,
        "height": 7.2,
        "motion": "fly",
        "accent": "#d8ad68"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 3,
      "aerialBoss": "skyTitan",
      "hazardPulse": 0.25,
      "intensity": 1
    }
  },
  "ancestral-invasion": {
    "family": "aurelios",
    "pieces": [
      {
        "id": "ancestral-invasion-world-0",
        "asset": "ceremonialAltar",
        "position": [
          -12.84,
          0,
          -10.504
        ],
        "rotationY": -0.22,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "ancestral-invasion-world-1",
        "asset": "elyonColumn",
        "position": [
          12.56,
          0,
          -10.336
        ],
        "rotationY": 0.33,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "ancestral-invasion-world-2",
        "asset": "ruinArch",
        "position": [
          -13.78,
          0,
          -15.168
        ],
        "rotationY": -0.44,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "ancestral-invasion-world-3",
        "asset": "brokenPillar",
        "position": [
          13.5,
          0,
          -15
        ],
        "rotationY": 0.55,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "ancestral-invasion-world-4",
        "asset": "ceremonialAltar",
        "position": [
          -8.22,
          0,
          -20.168
        ],
        "rotationY": -0.66,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "ancestral-invasion-world-5",
        "asset": "elyonColumn",
        "position": [
          7.9399999999999995,
          0,
          -20.336
        ],
        "rotationY": 0.77,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "ancestral-invasion-aerial-boss",
        "asset": "skyTitan",
        "position": [
          3.5,
          8.8,
          -27
        ],
        "rotationY": 0.68,
        "height": 7.2,
        "motion": "fly",
        "accent": "#d8ad68"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 5,
      "aerialBoss": "skyTitan",
      "hazardPulse": 0.45,
      "intensity": 1.24
    }
  },
  "astral-threshold": {
    "family": "capital",
    "pieces": [
      {
        "id": "astral-threshold-world-0",
        "asset": "guardianEast",
        "position": [
          -12,
          0,
          -10
        ],
        "rotationY": -0.22,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "astral-threshold-world-1",
        "asset": "guardianWest",
        "position": [
          11.72,
          0,
          -10.168
        ],
        "rotationY": 0.33,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "astral-threshold-world-2",
        "asset": "elyonColumn",
        "position": [
          -12.94,
          0,
          -15.336
        ],
        "rotationY": -0.44,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "astral-threshold-world-3",
        "asset": "elyonGateway",
        "position": [
          12.66,
          0,
          -15.504
        ],
        "rotationY": 0.55,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "astral-threshold-world-4",
        "asset": "guardianEast",
        "position": [
          -9.34,
          0,
          -20.504
        ],
        "rotationY": -0.66,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "astral-threshold-world-5",
        "asset": "guardianWest",
        "position": [
          9.06,
          0,
          -20.336
        ],
        "rotationY": 0.77,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "astral-threshold-aerial-boss",
        "asset": "astralLeviathan",
        "position": [
          0,
          8.15,
          -25
        ],
        "rotationY": 0.34,
        "height": 6.8,
        "motion": "fly",
        "accent": "#55d9ff"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 4,
      "aerialBoss": "astralLeviathan",
      "hazardPulse": 0.35,
      "intensity": 1.12
    }
  },
  "capital-siege": {
    "family": "capital",
    "pieces": [
      {
        "id": "capital-siege-world-0",
        "asset": "wallSegment",
        "position": [
          -11.72,
          0,
          -10.168
        ],
        "rotationY": -0.22,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "capital-siege-world-1",
        "asset": "capitalTower",
        "position": [
          11.44,
          0,
          -10.336
        ],
        "rotationY": 0.33,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "capital-siege-world-2",
        "asset": "capitalWall",
        "position": [
          -12.66,
          0,
          -15.504
        ],
        "rotationY": -0.44,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "capital-siege-world-3",
        "asset": "wallCorner",
        "position": [
          14.34,
          0,
          -15.504
        ],
        "rotationY": 0.55,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "capital-siege-world-4",
        "asset": "wallSegment",
        "position": [
          -9.06,
          0,
          -20.336
        ],
        "rotationY": -0.66,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "capital-siege-world-5",
        "asset": "capitalTower",
        "position": [
          8.78,
          0,
          -20.168
        ],
        "rotationY": 0.77,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "capital-siege-aerial-boss",
        "asset": "skyFortress",
        "position": [
          -3.5,
          9.45,
          -23
        ],
        "rotationY": 1.02,
        "height": 8.5,
        "motion": "fly",
        "accent": "#70aaff"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 6,
      "aerialBoss": "skyFortress",
      "hazardPulse": 0.55,
      "intensity": 1.3599999999999999
    }
  },
  "sky-fortress-assault": {
    "family": "capital",
    "pieces": [
      {
        "id": "sky-fortress-assault-world-0",
        "asset": "wallCorner",
        "position": [
          -12.28,
          0,
          -10.168
        ],
        "rotationY": -0.22,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "sky-fortress-assault-world-1",
        "asset": "wallSegment",
        "position": [
          12,
          0,
          -10
        ],
        "rotationY": 0.33,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "sky-fortress-assault-world-2",
        "asset": "capitalTower",
        "position": [
          -13.22,
          0,
          -15.168
        ],
        "rotationY": -0.44,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "sky-fortress-assault-world-3",
        "asset": "capitalWall",
        "position": [
          12.94,
          0,
          -15.336
        ],
        "rotationY": 0.55,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "sky-fortress-assault-world-4",
        "asset": "wallCorner",
        "position": [
          -7.66,
          0,
          -20.504
        ],
        "rotationY": -0.66,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "sky-fortress-assault-world-5",
        "asset": "wallSegment",
        "position": [
          9.34,
          0,
          -20.504
        ],
        "rotationY": 0.77,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "sky-fortress-assault-aerial-boss",
        "asset": "skyFortress",
        "position": [
          -3.5,
          8.8,
          -23
        ],
        "rotationY": 2.04,
        "height": 8.5,
        "motion": "fly",
        "accent": "#70aaff"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 5,
      "aerialBoss": "skyFortress",
      "hazardPulse": 0.35,
      "intensity": 1
    }
  },
  "ruined-kingdom": {
    "family": "aurelios",
    "pieces": [
      {
        "id": "ruined-kingdom-world-0",
        "asset": "ruinArch",
        "position": [
          -12.56,
          0,
          -10.336
        ],
        "rotationY": -0.22,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "ruined-kingdom-world-1",
        "asset": "brokenPillar",
        "position": [
          12.28,
          0,
          -10.168
        ],
        "rotationY": 0.33,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "ruined-kingdom-world-2",
        "asset": "toppledStatue",
        "position": [
          -13.5,
          0,
          -15
        ],
        "rotationY": -0.44,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "ruined-kingdom-world-3",
        "asset": "ceremonialAltar",
        "position": [
          13.22,
          0,
          -15.168
        ],
        "rotationY": 0.55,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "ruined-kingdom-world-4",
        "asset": "ruinArch",
        "position": [
          -7.9399999999999995,
          0,
          -20.336
        ],
        "rotationY": -0.66,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "ruined-kingdom-world-5",
        "asset": "brokenPillar",
        "position": [
          7.66,
          0,
          -20.504
        ],
        "rotationY": 0.77,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "ruined-kingdom-aerial-boss",
        "asset": "astryx",
        "position": [
          0,
          7.5,
          -25
        ],
        "rotationY": 1.36,
        "height": 5.6,
        "motion": "fly",
        "accent": "#e3b36b"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 3,
      "aerialBoss": "astryx",
      "hazardPulse": 0.65,
      "intensity": 1.48
    }
  },
  "crystal-cathedral": {
    "family": "xyloria",
    "pieces": [
      {
        "id": "crystal-cathedral-world-0",
        "asset": "guardianWest",
        "position": [
          -11.44,
          0,
          -10.336
        ],
        "rotationY": -0.22,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "crystal-cathedral-world-1",
        "asset": "elyonArch",
        "position": [
          11.16,
          0,
          -10.504
        ],
        "rotationY": 0.33,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "crystal-cathedral-world-2",
        "asset": "elyonColumn",
        "position": [
          -14.34,
          0,
          -15.504
        ],
        "rotationY": -0.44,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "crystal-cathedral-world-3",
        "asset": "guardianEast",
        "position": [
          14.06,
          0,
          -15.336
        ],
        "rotationY": 0.55,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "crystal-cathedral-world-4",
        "asset": "guardianWest",
        "position": [
          -8.78,
          0,
          -20.168
        ],
        "rotationY": -0.66,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "crystal-cathedral-world-5",
        "asset": "elyonArch",
        "position": [
          8.5,
          0,
          -20
        ],
        "rotationY": 0.77,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "crystal-cathedral-aerial-boss",
        "asset": "crystalDragon",
        "position": [
          3.5,
          8.15,
          -27
        ],
        "rotationY": 1.7000000000000002,
        "height": 6.4,
        "motion": "fly",
        "accent": "#63ffd1"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 4,
      "aerialBoss": "crystalDragon",
      "hazardPulse": 0.25,
      "intensity": 1.6
    }
  },
  "void-citadel": {
    "family": "capital",
    "pieces": [
      {
        "id": "void-citadel-world-0",
        "asset": "toppledStatue",
        "position": [
          -11.16,
          0,
          -10.504
        ],
        "rotationY": -0.22,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "void-citadel-world-1",
        "asset": "ruinArch",
        "position": [
          12.84,
          0,
          -10.504
        ],
        "rotationY": 0.33,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "void-citadel-world-2",
        "asset": "wallCorner",
        "position": [
          -14.06,
          0,
          -15.336
        ],
        "rotationY": -0.44,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "void-citadel-world-3",
        "asset": "elyonColumn",
        "position": [
          13.78,
          0,
          -15.168
        ],
        "rotationY": 0.55,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "void-citadel-world-4",
        "asset": "toppledStatue",
        "position": [
          -8.5,
          0,
          -20
        ],
        "rotationY": -0.66,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "void-citadel-world-5",
        "asset": "ruinArch",
        "position": [
          8.22,
          0,
          -20.168
        ],
        "rotationY": 0.77,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "void-citadel-aerial-boss",
        "asset": "voidMatriarch",
        "position": [
          0,
          9.45,
          -25
        ],
        "rotationY": 0,
        "height": 6.8,
        "motion": "fly",
        "accent": "#b06cff"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 6,
      "aerialBoss": "voidMatriarch",
      "hazardPulse": 0.45,
      "intensity": 1.12
    }
  },
  "storm-temple": {
    "family": "capital",
    "pieces": [
      {
        "id": "storm-temple-world-0",
        "asset": "elyonColumn",
        "position": [
          -12,
          0,
          -10
        ],
        "rotationY": -0.22,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "storm-temple-world-1",
        "asset": "guardianEast",
        "position": [
          11.72,
          0,
          -10.168
        ],
        "rotationY": 0.33,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "storm-temple-world-2",
        "asset": "guardianWest",
        "position": [
          -12.94,
          0,
          -15.336
        ],
        "rotationY": -0.44,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "storm-temple-world-3",
        "asset": "wallSegment",
        "position": [
          12.66,
          0,
          -15.504
        ],
        "rotationY": 0.55,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "storm-temple-world-4",
        "asset": "elyonColumn",
        "position": [
          -9.34,
          0,
          -20.504
        ],
        "rotationY": -0.66,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "storm-temple-world-5",
        "asset": "guardianEast",
        "position": [
          9.06,
          0,
          -20.336
        ],
        "rotationY": 0.77,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "storm-temple-aerial-boss",
        "asset": "stormPatriarch",
        "position": [
          3.5,
          7.5,
          -27
        ],
        "rotationY": 0.34,
        "height": 6.5,
        "motion": "fly",
        "accent": "#86c9ff"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 3,
      "aerialBoss": "stormPatriarch",
      "hazardPulse": 0.55,
      "intensity": 1.24
    }
  },
  "titan-sanctum": {
    "family": "aurelios",
    "pieces": [
      {
        "id": "titan-sanctum-world-0",
        "asset": "ruinArch",
        "position": [
          -12.84,
          0,
          -10.504
        ],
        "rotationY": -0.22,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "titan-sanctum-world-1",
        "asset": "toppledStatue",
        "position": [
          12.56,
          0,
          -10.336
        ],
        "rotationY": 0.33,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "titan-sanctum-world-2",
        "asset": "humanWall",
        "position": [
          -13.78,
          0,
          -15.168
        ],
        "rotationY": -0.44,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "titan-sanctum-world-3",
        "asset": "brokenPillar",
        "position": [
          13.5,
          0,
          -15
        ],
        "rotationY": 0.55,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "titan-sanctum-world-4",
        "asset": "ruinArch",
        "position": [
          -8.22,
          0,
          -20.168
        ],
        "rotationY": -0.66,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "titan-sanctum-world-5",
        "asset": "toppledStatue",
        "position": [
          7.9399999999999995,
          0,
          -20.336
        ],
        "rotationY": 0.77,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "titan-sanctum-aerial-boss",
        "asset": "petragon",
        "position": [
          -3.5,
          8.15,
          -23
        ],
        "rotationY": 0.68,
        "height": 8.2,
        "motion": "fly",
        "accent": "#ffbd72"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 4,
      "aerialBoss": "petragon",
      "hazardPulse": 0.65,
      "intensity": 1.3599999999999999
    }
  },
  "verdant-ruins": {
    "family": "xyloria",
    "pieces": [
      {
        "id": "verdant-ruins-world-0",
        "asset": "brokenPillar",
        "position": [
          -11.72,
          0,
          -10.168
        ],
        "rotationY": -0.22,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "verdant-ruins-world-1",
        "asset": "guardianEast",
        "position": [
          11.44,
          0,
          -10.336
        ],
        "rotationY": 0.33,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "verdant-ruins-world-2",
        "asset": "ceremonialAltar",
        "position": [
          -12.66,
          0,
          -15.504
        ],
        "rotationY": -0.44,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "verdant-ruins-world-3",
        "asset": "ruinArch",
        "position": [
          14.34,
          0,
          -15.504
        ],
        "rotationY": 0.55,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "verdant-ruins-world-4",
        "asset": "brokenPillar",
        "position": [
          -9.06,
          0,
          -20.336
        ],
        "rotationY": -0.66,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "verdant-ruins-world-5",
        "asset": "guardianEast",
        "position": [
          8.78,
          0,
          -20.168
        ],
        "rotationY": 0.77,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "verdant-ruins-aerial-boss",
        "asset": "ancientColossus",
        "position": [
          0,
          8.8,
          -25
        ],
        "rotationY": 1.02,
        "height": 7.4,
        "motion": "fly",
        "accent": "#71e59a"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 5,
      "aerialBoss": "ancientColossus",
      "hazardPulse": 0.25,
      "intensity": 1.48
    }
  },
  "magma-throne": {
    "family": "aurelios",
    "pieces": [
      {
        "id": "magma-throne-world-0",
        "asset": "brokenPillar",
        "position": [
          -12.56,
          0,
          -10.336
        ],
        "rotationY": -0.22,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "magma-throne-world-1",
        "asset": "humanWall",
        "position": [
          12.28,
          0,
          -10.168
        ],
        "rotationY": 0.33,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "magma-throne-world-2",
        "asset": "wallCorner",
        "position": [
          -13.5,
          0,
          -15
        ],
        "rotationY": -0.44,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "magma-throne-world-3",
        "asset": "ruinArch",
        "position": [
          13.22,
          0,
          -15.168
        ],
        "rotationY": 0.55,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "magma-throne-world-4",
        "asset": "brokenPillar",
        "position": [
          -7.9399999999999995,
          0,
          -20.336
        ],
        "rotationY": -0.66,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "magma-throne-world-5",
        "asset": "humanWall",
        "position": [
          7.66,
          0,
          -20.504
        ],
        "rotationY": 0.77,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "magma-throne-aerial-boss",
        "asset": "magmaLeviathan",
        "position": [
          3.5,
          9.45,
          -27
        ],
        "rotationY": 1.36,
        "height": 6.8,
        "motion": "fly",
        "accent": "#ff6c3f"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 6,
      "aerialBoss": "magmaLeviathan",
      "hazardPulse": 0.35,
      "intensity": 1.6
    }
  },
  "abyssal-rift": {
    "family": "capital",
    "pieces": [
      {
        "id": "abyssal-rift-world-0",
        "asset": "ruinArch",
        "position": [
          -11.44,
          0,
          -10.336
        ],
        "rotationY": -0.22,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "abyssal-rift-world-1",
        "asset": "toppledStatue",
        "position": [
          11.16,
          0,
          -10.504
        ],
        "rotationY": 0.33,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "abyssal-rift-world-2",
        "asset": "elyonColumn",
        "position": [
          -14.34,
          0,
          -15.504
        ],
        "rotationY": -0.44,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "abyssal-rift-world-3",
        "asset": "wallCorner",
        "position": [
          14.06,
          0,
          -15.336
        ],
        "rotationY": 0.55,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "abyssal-rift-world-4",
        "asset": "ruinArch",
        "position": [
          -8.78,
          0,
          -20.168
        ],
        "rotationY": -0.66,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "abyssal-rift-world-5",
        "asset": "toppledStatue",
        "position": [
          8.5,
          0,
          -20
        ],
        "rotationY": 0.77,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "abyssal-rift-aerial-boss",
        "asset": "abyssalMaw",
        "position": [
          -3.5,
          7.5,
          -23
        ],
        "rotationY": 1.7000000000000002,
        "height": 7.2,
        "motion": "fly",
        "accent": "#5077ff"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 3,
      "aerialBoss": "abyssalMaw",
      "hazardPulse": 0.45,
      "intensity": 1
    }
  },
  "celestial-bastion": {
    "family": "xyloria",
    "pieces": [
      {
        "id": "celestial-bastion-world-0",
        "asset": "guardianWest",
        "position": [
          -12.28,
          0,
          -10.168
        ],
        "rotationY": -0.22,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "celestial-bastion-world-1",
        "asset": "elyonGateway",
        "position": [
          12,
          0,
          -10
        ],
        "rotationY": 0.33,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "celestial-bastion-world-2",
        "asset": "elyonColumn",
        "position": [
          -13.22,
          0,
          -15.168
        ],
        "rotationY": -0.44,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "celestial-bastion-world-3",
        "asset": "guardianEast",
        "position": [
          12.94,
          0,
          -15.336
        ],
        "rotationY": 0.55,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "celestial-bastion-world-4",
        "asset": "guardianWest",
        "position": [
          -7.66,
          0,
          -20.504
        ],
        "rotationY": -0.66,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "celestial-bastion-world-5",
        "asset": "elyonGateway",
        "position": [
          9.34,
          0,
          -20.504
        ],
        "rotationY": 0.77,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "celestial-bastion-aerial-boss",
        "asset": "skyTitan",
        "position": [
          0,
          8.15,
          -25
        ],
        "rotationY": 2.04,
        "height": 7.8,
        "motion": "fly",
        "accent": "#f4d7ff"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 4,
      "aerialBoss": "skyTitan",
      "hazardPulse": 0.55,
      "intensity": 1.12
    }
  },
  "phoenix-temple": {
    "family": "aurelios",
    "pieces": [
      {
        "id": "phoenix-temple-world-0",
        "asset": "ceremonialAltar",
        "position": [
          -11.16,
          0,
          -10.504
        ],
        "rotationY": -0.22,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "phoenix-temple-world-1",
        "asset": "guardianEast",
        "position": [
          12.84,
          0,
          -10.504
        ],
        "rotationY": 0.33,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "phoenix-temple-world-2",
        "asset": "ruinArch",
        "position": [
          -14.06,
          0,
          -15.336
        ],
        "rotationY": -0.44,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "phoenix-temple-world-3",
        "asset": "elyonArch",
        "position": [
          13.78,
          0,
          -15.168
        ],
        "rotationY": 0.55,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "phoenix-temple-world-4",
        "asset": "ceremonialAltar",
        "position": [
          -8.5,
          0,
          -20
        ],
        "rotationY": -0.66,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "phoenix-temple-world-5",
        "asset": "guardianEast",
        "position": [
          8.22,
          0,
          -20.168
        ],
        "rotationY": 0.77,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "phoenix-temple-aerial-boss",
        "asset": "phoenixPrime",
        "position": [
          3.5,
          8.8,
          -27
        ],
        "rotationY": 0,
        "height": 6.4,
        "motion": "fly",
        "accent": "#ff9e4f"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 5,
      "aerialBoss": "phoenixPrime",
      "hazardPulse": 0.65,
      "intensity": 1.24
    }
  },
  "thermal-spires": {
    "family": "aurelios",
    "pieces": [
      {
        "id": "thermal-spires-world-0",
        "asset": "elyonColumn",
        "position": [
          -12,
          0,
          -10
        ],
        "rotationY": -0.22,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "thermal-spires-world-1",
        "asset": "capitalWall",
        "position": [
          11.72,
          0,
          -10.168
        ],
        "rotationY": 0.33,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "thermal-spires-world-2",
        "asset": "wallCorner",
        "position": [
          -12.94,
          0,
          -15.336
        ],
        "rotationY": -0.44,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "thermal-spires-world-3",
        "asset": "wallSegment",
        "position": [
          12.66,
          0,
          -15.504
        ],
        "rotationY": 0.55,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "thermal-spires-world-4",
        "asset": "elyonColumn",
        "position": [
          -9.34,
          0,
          -20.504
        ],
        "rotationY": -0.66,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "thermal-spires-world-5",
        "asset": "capitalWall",
        "position": [
          9.06,
          0,
          -20.336
        ],
        "rotationY": 0.77,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "thermal-spires-aerial-boss",
        "asset": "thermalWyvern",
        "position": [
          -3.5,
          9.45,
          -23
        ],
        "rotationY": 0.34,
        "height": 6.3,
        "motion": "fly",
        "accent": "#ff7855"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 6,
      "aerialBoss": "thermalWyvern",
      "hazardPulse": 0.25,
      "intensity": 1.3599999999999999
    }
  },
  "shadow-leviathan": {
    "family": "capital",
    "pieces": [
      {
        "id": "shadow-leviathan-world-0",
        "asset": "toppledStatue",
        "position": [
          -12.84,
          0,
          -10.504
        ],
        "rotationY": -0.22,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "shadow-leviathan-world-1",
        "asset": "ruinArch",
        "position": [
          12.56,
          0,
          -10.336
        ],
        "rotationY": 0.33,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "shadow-leviathan-world-2",
        "asset": "wallCorner",
        "position": [
          -13.78,
          0,
          -15.168
        ],
        "rotationY": -0.44,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "shadow-leviathan-world-3",
        "asset": "brokenPillar",
        "position": [
          13.5,
          0,
          -15
        ],
        "rotationY": 0.55,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "shadow-leviathan-world-4",
        "asset": "toppledStatue",
        "position": [
          -8.22,
          0,
          -20.168
        ],
        "rotationY": -0.66,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "shadow-leviathan-world-5",
        "asset": "ruinArch",
        "position": [
          7.9399999999999995,
          0,
          -20.336
        ],
        "rotationY": 0.77,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "shadow-leviathan-aerial-boss",
        "asset": "shadowLeviathan",
        "position": [
          0,
          7.5,
          -25
        ],
        "rotationY": 0.68,
        "height": 7,
        "motion": "fly",
        "accent": "#8064d8"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 3,
      "aerialBoss": "shadowLeviathan",
      "hazardPulse": 0.35,
      "intensity": 1.48
    }
  },
  "void-leviathan-gate": {
    "family": "capital",
    "pieces": [
      {
        "id": "void-leviathan-gate-world-0",
        "asset": "wallSegment",
        "position": [
          -11.72,
          0,
          -10.168
        ],
        "rotationY": -0.22,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "void-leviathan-gate-world-1",
        "asset": "guardianWest",
        "position": [
          11.44,
          0,
          -10.336
        ],
        "rotationY": 0.33,
        "height": 6.16,
        "motion": "static"
      },
      {
        "id": "void-leviathan-gate-world-2",
        "asset": "elyonColumn",
        "position": [
          -12.66,
          0,
          -15.504
        ],
        "rotationY": -0.44,
        "height": 6.779999999999999,
        "motion": "static"
      },
      {
        "id": "void-leviathan-gate-world-3",
        "asset": "elyonGateway",
        "position": [
          14.34,
          0,
          -15.504
        ],
        "rotationY": 0.55,
        "height": 4.3,
        "motion": "static"
      },
      {
        "id": "void-leviathan-gate-world-4",
        "asset": "wallSegment",
        "position": [
          -9.06,
          0,
          -20.336
        ],
        "rotationY": -0.66,
        "height": 4.92,
        "motion": "static"
      },
      {
        "id": "void-leviathan-gate-world-5",
        "asset": "guardianWest",
        "position": [
          8.78,
          0,
          -20.168
        ],
        "rotationY": 0.77,
        "height": 5.54,
        "motion": "static"
      },
      {
        "id": "void-leviathan-gate-aerial-boss",
        "asset": "voidLeviathan",
        "position": [
          3.5,
          8.15,
          -27
        ],
        "rotationY": 1.02,
        "height": 7.5,
        "motion": "fly",
        "accent": "#6677ff"
      }
    ],
    "encounter": {
      "kind": "invasion",
      "waves": 4,
      "aerialBoss": "voidLeviathan",
      "hazardPulse": 0.45,
      "intensity": 1.6
    }
  }
}

export const EXPANDED_ARENAS:ArenaDef[]=[
  {
    "id": "megalithic-sanctum",
    "name": "SANTUÃRIO MEGALÃTICO",
    "region": "Reino Humano Ancestral",
    "landmarkId": "megalithicTemple",
    "landmarkUrl": "/elyon/world-library/prop/megalithicTemple.glb",
    "landmarkScale": 8.5,
    "landmarkPosition": [
      0,
      0,
      -6
    ],
    "landmarkRotation": [
      0,
      0,
      0
    ],
    "sky": "#24150f",
    "ground": "#17100c",
    "accent": "#d8ad68",
    "fog": "#120b08",
    "worldActors": []
  },
  {
    "id": "ancestral-invasion",
    "name": "INVASÃƒO ANCESTRAL",
    "region": "Cidade MegalÃ­tica Sitada",
    "landmarkId": "megalithicTemple",
    "landmarkUrl": "/elyon/world-library/prop/megalithicTemple.glb",
    "landmarkScale": 8.5,
    "landmarkPosition": [
      0,
      0,
      -8
    ],
    "landmarkRotation": [
      0,
      0.785398,
      0
    ],
    "sky": "#24150f",
    "ground": "#17100c",
    "accent": "#d8ad68",
    "fog": "#120b08",
    "worldActors": []
  },
  {
    "id": "astral-threshold",
    "name": "LIMIAR ASTRAL",
    "region": "Portal de Elyon",
    "landmarkId": "astralGateway",
    "landmarkUrl": "/elyon/world-library/prop/astralGateway.glb",
    "landmarkScale": 8.2,
    "landmarkPosition": [
      0,
      0,
      -7
    ],
    "landmarkRotation": [
      0,
      0.392699,
      0
    ],
    "sky": "#071322",
    "ground": "#081019",
    "accent": "#55d9ff",
    "fog": "#040812",
    "worldActors": []
  },
  {
    "id": "capital-siege",
    "name": "CERCO DA CAPITAL",
    "region": "Muralhas da Capital",
    "landmarkId": "capitalObelisk",
    "landmarkUrl": "/elyon/world-library/prop/capitalObelisk.glb",
    "landmarkScale": 8.8,
    "landmarkPosition": [
      0,
      0,
      -6
    ],
    "landmarkRotation": [
      0,
      1.1780970000000002,
      0
    ],
    "sky": "#0a1220",
    "ground": "#0c1118",
    "accent": "#70aaff",
    "fog": "#050912",
    "worldActors": []
  },
  {
    "id": "sky-fortress-assault",
    "name": "ASSALTO Ã€ FORTALEZA CELESTE",
    "region": "CÃ©u da Capital",
    "landmarkId": "capitalObelisk",
    "landmarkUrl": "/elyon/world-library/prop/capitalObelisk.glb",
    "landmarkScale": 8.8,
    "landmarkPosition": [
      0,
      0,
      -6
    ],
    "landmarkRotation": [
      0,
      2.3561940000000003,
      0
    ],
    "sky": "#0a1220",
    "ground": "#0c1118",
    "accent": "#70aaff",
    "fog": "#050912",
    "worldActors": []
  },
  {
    "id": "ruined-kingdom",
    "name": "REINO EM RUÃNAS",
    "region": "Cidade Perdida",
    "landmarkId": "ancientRuins",
    "landmarkUrl": "/elyon/world-library/prop/ancientRuins.glb",
    "landmarkScale": 7.8,
    "landmarkPosition": [
      0,
      0,
      -7
    ],
    "landmarkRotation": [
      0,
      1.570796,
      0
    ],
    "sky": "#302016",
    "ground": "#18110d",
    "accent": "#e3b36b",
    "fog": "#130d09",
    "worldActors": []
  },
  {
    "id": "crystal-cathedral",
    "name": "CATEDRAL DE CRISTAL",
    "region": "Xyloria Profunda",
    "landmarkId": "crystalTemple",
    "landmarkUrl": "/elyon/world-library/prop/crystalTemple.glb",
    "landmarkScale": 8.1,
    "landmarkPosition": [
      0,
      0,
      -8
    ],
    "landmarkRotation": [
      0,
      1.963495,
      0
    ],
    "sky": "#082129",
    "ground": "#061713",
    "accent": "#63ffd1",
    "fog": "#04110f",
    "worldActors": []
  },
  {
    "id": "void-citadel",
    "name": "CIDADELA DO VAZIO",
    "region": "Fenda do Vazio",
    "landmarkId": "elyonGateway",
    "landmarkUrl": "/elyon/world-library/prop/elyonGateway.glb",
    "landmarkScale": 8.4,
    "landmarkPosition": [
      0,
      0,
      -7
    ],
    "landmarkRotation": [
      0,
      2.7488930000000003,
      0
    ],
    "sky": "#100819",
    "ground": "#0d0812",
    "accent": "#b06cff",
    "fog": "#07040c",
    "worldActors": []
  },
  {
    "id": "storm-temple",
    "name": "TEMPLO DA TEMPESTADE",
    "region": "Altos de Elyon",
    "landmarkId": "megalithicTemple",
    "landmarkUrl": "/elyon/world-library/prop/megalithicTemple.glb",
    "landmarkScale": 8.3,
    "landmarkPosition": [
      0,
      0,
      -8
    ],
    "landmarkRotation": [
      0,
      0,
      0
    ],
    "sky": "#101927",
    "ground": "#0b111a",
    "accent": "#86c9ff",
    "fog": "#070c13",
    "worldActors": []
  },
  {
    "id": "titan-sanctum",
    "name": "SANTUÃRIO DOS TITÃƒS",
    "region": "Vale dos Colossos",
    "landmarkId": "ceremonialAltar",
    "landmarkUrl": "/elyon/world-library/prop/ceremonialAltar.glb",
    "landmarkScale": 6.4,
    "landmarkPosition": [
      0,
      0,
      -6
    ],
    "landmarkRotation": [
      0,
      0.392699,
      0
    ],
    "sky": "#2b1c13",
    "ground": "#17100d",
    "accent": "#ffbd72",
    "fog": "#100a07",
    "worldActors": []
  },
  {
    "id": "verdant-ruins",
    "name": "RUÃNAS VERDANTES",
    "region": "Floresta Ancestral",
    "landmarkId": "ancientRuins",
    "landmarkUrl": "/elyon/world-library/prop/ancientRuins.glb",
    "landmarkScale": 7.5,
    "landmarkPosition": [
      0,
      0,
      -7
    ],
    "landmarkRotation": [
      0,
      0.785398,
      0
    ],
    "sky": "#071b18",
    "ground": "#08140d",
    "accent": "#71e59a",
    "fog": "#04100b",
    "worldActors": []
  },
  {
    "id": "magma-throne",
    "name": "TRONO DE MAGMA",
    "region": "CinturÃ£o VulcÃ¢nico",
    "landmarkId": "megalithicTemple",
    "landmarkUrl": "/elyon/world-library/prop/megalithicTemple.glb",
    "landmarkScale": 8.2,
    "landmarkPosition": [
      0,
      0,
      -8
    ],
    "landmarkRotation": [
      0,
      1.1780970000000002,
      0
    ],
    "sky": "#2a0c09",
    "ground": "#190a08",
    "accent": "#ff6c3f",
    "fog": "#120504",
    "worldActors": []
  },
  {
    "id": "abyssal-rift",
    "name": "FENDA ABISSAL",
    "region": "Abismo de Elyon",
    "landmarkId": "ancientRuins",
    "landmarkUrl": "/elyon/world-library/prop/ancientRuins.glb",
    "landmarkScale": 7.6,
    "landmarkPosition": [
      0,
      0,
      -6
    ],
    "landmarkRotation": [
      0,
      1.570796,
      0
    ],
    "sky": "#060b15",
    "ground": "#070912",
    "accent": "#5077ff",
    "fog": "#03050b",
    "worldActors": []
  },
  {
    "id": "celestial-bastion",
    "name": "BASTIÃƒO CELESTIAL",
    "region": "DomÃ­nio Serafim",
    "landmarkId": "seraphimGuardian",
    "landmarkUrl": "/elyon/world-library/prop/seraphimGuardian.glb",
    "landmarkScale": 9,
    "landmarkPosition": [
      0,
      0,
      -7
    ],
    "landmarkRotation": [
      0,
      1.963495,
      0
    ],
    "sky": "#111a2c",
    "ground": "#0b1220",
    "accent": "#f4d7ff",
    "fog": "#070c16",
    "worldActors": []
  },
  {
    "id": "phoenix-temple",
    "name": "TEMPLO DA FÃŠNIX",
    "region": "SantuÃ¡rio Solar",
    "landmarkId": "astralGateway",
    "landmarkUrl": "/elyon/world-library/prop/astralGateway.glb",
    "landmarkScale": 7.9,
    "landmarkPosition": [
      0,
      0,
      -8
    ],
    "landmarkRotation": [
      0,
      2.3561940000000003,
      0
    ],
    "sky": "#32130d",
    "ground": "#180b08",
    "accent": "#ff9e4f",
    "fog": "#140705",
    "worldActors": []
  },
  {
    "id": "thermal-spires",
    "name": "AGULHAS TERMAIS",
    "region": "Fronteira Ãgnea",
    "landmarkId": "capitalTower",
    "landmarkUrl": "/elyon/world-library/prop/capitalTower.glb",
    "landmarkScale": 8.6,
    "landmarkPosition": [
      0,
      0,
      -6
    ],
    "landmarkRotation": [
      0,
      2.7488930000000003,
      0
    ],
    "sky": "#29100e",
    "ground": "#160c0a",
    "accent": "#ff7855",
    "fog": "#110706",
    "worldActors": []
  },
  {
    "id": "shadow-leviathan",
    "name": "MAR DAS SOMBRAS",
    "region": "DomÃ­nio Vazio",
    "landmarkId": "elyonGateway",
    "landmarkUrl": "/elyon/world-library/prop/elyonGateway.glb",
    "landmarkScale": 8.2,
    "landmarkPosition": [
      0,
      0,
      -7
    ],
    "landmarkRotation": [
      0,
      0,
      0
    ],
    "sky": "#090711",
    "ground": "#08070d",
    "accent": "#8064d8",
    "fog": "#040308",
    "worldActors": []
  },
  {
    "id": "void-leviathan-gate",
    "name": "PORTÃƒO DO LEVIATÃƒ",
    "region": "Horizonte do Vazio",
    "landmarkId": "astralGateway",
    "landmarkUrl": "/elyon/world-library/prop/astralGateway.glb",
    "landmarkScale": 8.6,
    "landmarkPosition": [
      0,
      0,
      -8
    ],
    "landmarkRotation": [
      0,
      0.392699,
      0
    ],
    "sky": "#070a16",
    "ground": "#070914",
    "accent": "#6677ff",
    "fog": "#03040b",
    "worldActors": []
  }
]
